import AnalyticsRepository from './AnalyticsRepository';

export default AnalyticsRepository;
